import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const staff = t.type({
  id: h.omittable(t.number),
  staff_id: t.string,
  display_name: t.string,
  first_name: t.string,
  last_name: t.string,
  avatar_url: h.omittable(t.string),
  role: t.string,
  email: t.string,
  last_login: h.omittable(t.string),
  agency_id: h.omittable(t.number),
});

export type Staff = t.TypeOf<typeof staff>;

export const staffQuery = t.partial({
  page: h.number().cast(),
  email: t.string,
  display_name: t.string,
  staff_id: t.string,
  role: t.string,
  agency_id: h.number().cast(),
});

export type StaffQuery = t.TypeOf<typeof staffQuery>;
